/**
 * Multiselect
 */
import React from 'react';
import { Fieldset, Checkbox } from '../index';
var Multiselect = function (_a) {
    var id = _a.id, required = _a.required, label = _a.label, isInvalid = _a.isInvalid, validationMessage = _a.validationMessage, options = _a.options, onFieldChange = _a.onFieldChange;
    return (React.createElement(Fieldset, { id: id, required: required, label: label, isInvalid: isInvalid, validationMessage: validationMessage }, options.map(function (opt, index) {
        return (React.createElement(Checkbox, { id: id + "-" + index, name: id, value: opt.value, label: opt.caption, key: id + "-" + index, onFieldChange: onFieldChange }, opt.caption));
    })));
};
export default Multiselect;
